import {
  CollapsibleGraphGroup,
  GROUP_HEADER_FONT_HEIGHT,
  GraphGroup,
  estimateCountLabelWidth,
} from '@ardoq/graph';
import {
  BLOCK_DIAGRAM_GROUP_HEADER_AFTER_EXPANDER_X,
  GROUP_PADDING,
  HEADER_ICON_PADDING,
  HEADER_ICON_SIZE,
  PREFERRED_MINIMUM_GROUP_WIDTH,
  SUBHEADER_FONT_HEIGHT,
} from './consts';
import { URL_ICON_MARGIN, URL_ICON_SIZE } from 'yfilesExtensions/styles/consts';
import { Font, FontStyle, INode } from '@ardoq/yfiles';
import { RepresentationData } from '@ardoq/data-model';
import { canvasLabelMeasurer } from '@ardoq/graph-labeling';
import { ARDOQ_DEFAULT_FONT_FAMILY } from '@ardoq/typography';
import { fontFamily } from '@ardoq/design-tokens';

const getRepresentationDataWidth = (
  representationData: RepresentationData | null
) => (representationData ? HEADER_ICON_SIZE + HEADER_ICON_PADDING : 0);

export const folderStyleGroupLabelStartX = (group: GraphGroup) => {
  const representationData = group.getRepresentationData();
  return (
    BLOCK_DIAGRAM_GROUP_HEADER_AFTER_EXPANDER_X +
    getRepresentationDataWidth(representationData)
  );
};

export const getGroupHeaderWidthWithoutLabel = (
  group: CollapsibleGraphGroup
) => {
  const urlIconsSpace =
    group.isComponent() || group.isReference()
      ? URL_ICON_SIZE + URL_ICON_MARGIN * 2
      : 0;
  const countLabelWidth = group.collapsed
    ? estimateCountLabelWidth(group.descendantCount)
    : 0;

  return (
    folderStyleGroupLabelStartX(group) +
    urlIconsSpace +
    countLabelWidth +
    GROUP_PADDING * 2
  );
};

export const getGroupLabelMaxWidth = (groupNode: INode | null) => {
  if (!groupNode) {
    return 0;
  }
  const { tag: group, layout } = groupNode;

  return (
    Math.max(layout.width, PREFERRED_MINIMUM_GROUP_WIDTH) -
    getGroupHeaderWidthWithoutLabel(group)
  );
};

const GROUP_LABEL_FONT = `normal ${GROUP_HEADER_FONT_HEIGHT}px/normal ${fontFamily.regular}`;
const SUBHEADER_LABEL_FONT = `normal ${SUBHEADER_FONT_HEIGHT}px/normal ${fontFamily.regular}`;
export const measureGroupLabel = canvasLabelMeasurer(GROUP_LABEL_FONT);
export const measureGroupSubLabel = canvasLabelMeasurer(SUBHEADER_LABEL_FONT);

export const getElementOpacityIfTransparentized = (
  isTransparentized: boolean,
  opacity = 0.32
) => (!isTransparentized ? 1 : opacity);

export const GROUP_SUBLABEL_FONT = new Font({
  fontFamily: ARDOQ_DEFAULT_FONT_FAMILY,
  fontSize: 14,
  fontWeight: 'normal',
  fontStyle: FontStyle.ITALIC,
});
